<template>
  <div class="navigation_left">
    <!-- <div class="head">
      <img
        src="../assets/imgs/logo.png"
        alt=""
      >
    </div> -->
    <div class="img">
      <div>
        <img
          src="../assets/imgs/tubiao.png"
          alt=""
        />
      </div>
      <span style="margin-left: 12px">新华杯</span>
    </div>
    <el-menu
      class="el-menu-vertical-demo"
      :default-openeds="openeds"
      @select="handleSelect"
      :unique-opened="true"
    >
      <el-submenu
        :index="item.id.toString()"
        v-for="(item, index) in navigationList"
        :key="item.id"
      >
        <template slot="title">
          <img
            style="width: 20px; height: 20px; margin-right: 10px"
            :src="iconList[index]"
            alt=""
          />
          <span>{{ item.name }}</span>
        </template>
        <el-menu-item-group
          :class="$route.fullPath==i.path? 'active' : ''"
          v-for="(i) in item.children"
          :key="i.id"
        >
          <el-menu-item
            v-if="i.name != '新建比赛' && i.name != '大赛公告'"
            :index="i.id.toString()"
          >{{ i.name }}</el-menu-item>
        </el-menu-item-group>
      </el-submenu>
    </el-menu>
  </div>
</template>

<script>
// import navigationList from '../tool/navigation.js'
import { treeRoleALLByuserId } from "../api/api_b";
export default {
  data() {
    return {
      // navigationList: navigationList.navigationList,
      navigationList: [],
      openeds: localStorage.getItem("indexOpeneds") ? [localStorage.getItem("indexOpeneds")] : [""],
      iconList: [
        require("../assets/imgs/home.png"),
        require("../assets/imgs/compt.png"),
        require("../assets/imgs/yunying.png"),
        require("../assets/imgs/users.png"),
        require("../assets/imgs/model.png"),
        require("../assets/imgs/system.png"),
      ],
    };
  },
  created() {
    this.treeRoleALLByuserId(localStorage.getItem("userId_b"));
  },
  mounted() {
    // if (this.navigationList.length !== 0) {
    //   this.navigationList.forEach((i, index) => {
    //     this.openeds = [index.toString()]
    //   })
    // }
    // console.log(this.openeds, 'this.openeds');
    if (localStorage.getItem("userType_b") == 0) {
      // console.log(navigationList.navigationList);
      // navigationList.navigationList.splice(2, 1);
      this.navigationList.splice(2, 1);
      // console.log(this.navigationList);
    }
  },
  methods: {
    treeRoleALLByuserId(userId) {
      treeRoleALLByuserId({ userId: userId }).then((res) => {
        if (res.status === 200) {
          if (res.data.content.length == 0) {
            this.$router.push({
              path: '/layout/empty'
            })
          } else {
            //   res.data.content.forEach(item => {
            //   if(item.name=='首页'){
            //     this.$router.push("/layout/homepage");
            //   }else{
            //     this.$router.push(res.data.content[0].children[0].path);
            //   }
            // });
            this.navigationList = res.data.content;
            console.log(this.$route)
            console.log(res.data.content)
            var flag = false
            var funList = []
            res.data.content.forEach(item => {
              item.children.forEach(el => {
                if (el.path == this.$route) {
                  flag = true
                  funList = el.functionList
                } else {
                  flag = false
                }
              })
            });
            // this.$router.push(res.data.content[0].children[0].path)
            if (flag) {
              this.$router.push({
                path: this.$route.fullPath
              })
              localStorage.setItem("fun", JSON.stringify(funList));
            } else {
              this.$router.push(res.data.content[0].children[0].path)
              localStorage.setItem(
                "fun",
                JSON.stringify(
                  res.data.content[0].children[0].functionList
                )
              );
            }

          }

          // localStorage.setItem('menuList', JSON.stringify(res.data.content))
        }
      });
    },
    handleSelect(index, indexPath) {
      localStorage.setItem("indexOpeneds", indexPath[0].toString());
      // this.openeds.push([indexPath[0].toString()])
      // console.log(this.navigationList[Number(indexPath[0])].children[Number(indexPath[1])].functionList)
      // this.navigationList.forEach((i, index) => {
      //   this.openeds=[index.toString()]
      // })


      const path1 = this.navigationList.filter(item => item.id === Number(indexPath[0]))
      const path2 = path1[0].children.filter(li => li.id === Number(indexPath[1]))
      const selectPath = path2[0].path
      if (
        this.$route.fullPath !== selectPath
      ) {
        this.$router.push({
          path: selectPath,
          // query:{
          //   fun:JSON.stringify(this.navigationList[Number(indexPath[0])].children[Number(indexPath[1])].functionList),
          // }
        });
        localStorage.setItem(
          "fun",
          JSON.stringify(
            path2[0].functionList
          )
        );
      }
      // console.log(this.navigationList[Number(indexPath[0])].child[Number(indexPath[1])].path)
    },
  },
  watch: {
    $route(val, val1) {
      if (val.path === "/layout/newCompetition") {
        this.$nextTick(() => {
          this.openeds = ["1"];
        });
      }
    },
  },
};
</script>

<style scoped lang="less">
.navigation_left {
  height: calc(100vh - 0px);
  background-color: #232b3b;
  // .head {
  //   width: 100%;
  //   overflow: hidden;
  //   background-color: #232b3b;
  //   height: 58px;
  //   line-height: 58px;
  //   text-align: center;
  //   img {
  //     margin-top: 15px;
  //   }
  //   .logo {
  //     float: left;
  //     background-color: #fff;
  //     width: 35px;
  //     height: 35px;
  //     position: relative;
  //     top: 10px;
  //   }
  //   .text {
  //     line-height: 50px;
  //     text-align: center;
  //     color: #fff;
  //     font-size: 20px;
  //     font-weight: 600;
  //   }
  // }
  .img {
    display: flex;
    justify-content: center;
    align-items: center;
    padding-top: 15px;
    width: 100%;
    height: 56px;
    // float: left;
    // width: 340px;
    // height: 60px;
    // padding-top: 15px;
    // margin-right: 30px;
    // span {
    //   float: right;
    //    background: url("../assets/imgs/tubiao.png") no-repeat;
    //   background-size: 100% 100%;
    // }
    div {
      width: 20%;
      height: 100%;
      img {
        width: 100%;
        height: 100%;
      }
    }
    span:nth-child(2) {
      font-size: 22px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #ffffff;
    }
  }
  width: 100%;
  /deep/.el-menu {
    border: none;
    .active {
      background: linear-gradient(360deg, #297dcf 0%, #399dff 100%);
    }
    .el-menu-item.is-active {
      background-color: #145afe !important;
      color: #fff;
      span {
        color: #fff !important;
      }
    }
    // .el-menu-item-group {
    //   .is-active {
    //     background-color: #1990ff;
    //   }
    // }
    width: 100%;
    background-color: #232b3b;
    .el-menu-item-group__title {
      padding: 0 !important;
    }
    .el-submenu {
      width: 100%;
      .el-submenu__title {
        padding-left: 10% !important;
      }
      .el-menu-item {
        padding-left: 20% !important;
        height: 56px !important;
        line-height: 56px !important;
      }
    }
    .el-submenu__icon-arrow {
      right: 10%;
    }
    .el-submenu__title {
      width: 100%;
      color: #fff;
    }
    .el-submenu__title {
      &:hover {
        background-color: rgba(25, 144, 255, 0.6);
      }
    }
    .el-menu-item {
      min-width: 100px;
      color: #fff !important;
      &:hover {
        background-color: rgba(25, 144, 255, 0.6) !important;
      }
    }
    .el-menu--inline {
      background-color: #232b3b !important;
    }
  }
}

/deep/.el-menu .active {
  background: #145afe !important;
}
</style>
